import { Button } from 'shared/ui/Button';

export const EditNoteButton = ({ toggleNoteEdit }) => (
  <Button
    className={'btn-box-tool btn-sm no-padding margin-left margin-right'}
    type="button"
    id="add-skill-note"
    onClick={toggleNoteEdit}
  >
    <i className="fa fa-sticky-note-o" />
  </Button>
);
